
import { useEffect, useMemo, useState } from "react";
import {
  Button,
  Container,
  Form,
  Modal,
  Spinner,
  Toast,
  ToastContainer,
} from "react-bootstrap";

import config from "../devprodConfig";
import { useUser } from "../context/UserContext";
import {
  getKoulutukset,
  createKoulutus,
  updateKoulutus,
  deleteKoulutus,

  getPatevyydet,
  createPatevyys,
  updatePatevyys,
  deletePatevyys,

  getKielitaidot,
  createKielitaito,
  updateKielitaito,
  deleteKielitaito,

  getTyokokemukset,
  createTyokokemus,
  updateTyokokemus,
  deleteTyokokemus,
  getItLaitteet,
  createItLaite,
  updateItLaite,
  deleteItLaite,
  getLaitteet,
  createLaite,
  updateLaite,
  deleteLaite,
  getReferenssit,
  createReferenssi,
  updateReferenssi,
  deleteReferenssi,

  getYritysReferenssit,
  createYritysReferenssi,
  updateYritysReferenssi,
  deleteYritysReferenssi,
  getHuollot,
  createHuolto,
  updateHuolto,
  deleteHuolto,
  
} from "../api/api"
const ROLE_OPTIONS = [
  { value: "vieras", label: "Vieras" },
  { value: "tyontekija", label: "Työntekijä" },
  { value: "myyjä", label: "Myyjä" },
  { value: "lvi", label: "LVI" },
  { value: "sähkö", label: "Sähkö" },
  { value: "rakennetekniikka", label: "Rakennetekniikka" },
  { value: "admin", label: "Admin" },
];
const EMPTY_IT_DEVICE = {
  id: null,
  laitetyyppi: "",
  merkki_malli: "",
  hankintapaiva: "",
  leasing: false,
  leasing_paattymispaiva: "",
};
const EMPTY_NEW_USER = {
  nimi: "",
  sahkoposti: "",
  puhelinnumero: "",
  ammattinimike: "",
  yritys: "",
  osoite: "",
  postinumero: "",
  toimipaikka: "",
  rooli: "vieras",
};

const EMPTY_DEVICE = {
  id: null,
  laitenimi: "",
  merkki_malli: "",
  hankintapaiva: "",
  leasing: false,
  leasing_paattymispaiva: "",
  kalibroitava: false,
  kalibrointipaiva: "",
  kalibroinnin_uusintapaiva: "",
  vastuuhenkilo_id: null,
  varastossa: false,
};

const EMPTY_MAINTENANCE = {
  paivamaara: "",
  selite: "",
};

export default function Kayttajahallinta() {
  const { meUser, localUser, loading: userLoading } = useUser();

  const currentUser = meUser || localUser;
  const canManageUsers = currentUser?.rooli === "admin";

  const [users, setUsers] = useState([]);
  const [kiinteistot, setKiinteistot] = useState([]);
  const [assignments, setAssignments] = useState({});

  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [savingEdit, setSavingEdit] = useState(false);
  const [savingAssignmentsUserId, setSavingAssignmentsUserId] =
    useState(null);

  const [expandedUserId, setExpandedUserId] = useState(null);
  const [searchTerms, setSearchTerms] = useState({});
  const [roleFilter, setRoleFilter] = useState("all");
  const [userSearch, setUserSearch] = useState("");

  const [newUser, setNewUser] = useState(EMPTY_NEW_USER);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [editTab, setEditTab] = useState("perustiedot");

  const [koulutukset, setKoulutukset] = useState([]);
  const [patevyydet, setPatevyydet] = useState([]);
  const [kielitaidot, setKielitaidot] = useState([]);
  const [tyokokemukset, setTyokokemukset] = useState([]);

  const [referenssit, setReferenssit] = useState([]);
  const [yritysReferenssit, setYritysReferenssit] = useState([]);

  const [deletedReferenssit, setDeletedReferenssit] = useState([]);
  const [deletedYritysReferenssit, setDeletedYritysReferenssit] = useState([]);

  const [itLaitteet, setItLaitteet] = useState([]);
  const [itLaitteetLoading, setItLaitteetLoading] = useState(false);
  const [editingItDevice, setEditingItDevice] = useState(null);
  const [savingItDevice, setSavingItDevice] = useState(false);
  const [deletedKoulutusIds, setDeletedKoulutusIds] = useState([]);
  const [deletedPatevyysIds, setDeletedPatevyysIds] = useState([]);
  const [deletedKielitaitoIds, setDeletedKielitaitoIds] = useState([]);
  const [deletedTyokokemusIds, setDeletedTyokokemusIds] = useState([]);
  // Laitehallinta
  const [devices, setDevices] = useState([]);
  const [devicesLoading, setDevicesLoading] = useState(false);

  const [showDeviceModal, setShowDeviceModal] = useState(false);
  const [editingDevice, setEditingDevice] = useState(EMPTY_DEVICE);
  const [savingDevice, setSavingDevice] = useState(false);

  const [maintenanceRows, setMaintenanceRows] = useState([]);
  const [maintenanceLoading, setMaintenanceLoading] = useState(false);
  const [newMaintenance, setNewMaintenance] =
    useState(EMPTY_MAINTENANCE);
  const [savingMaintenance, setSavingMaintenance] = useState(false);

  const [toast, setToast] = useState({
    show: false,
    message: "",
    bg: "",
  });

  useEffect(() => {
    if (userLoading) return;

    if (!canManageUsers) {
      setLoading(false);
      return;
    }

    const loadData = async () => {
      try {
        setLoading(true);

        const [usersResponse, propertiesResponse] = await Promise.all([
          fetch(`${config.apiBaseUrl}/api/users`, {
            credentials: "include",
          }),
          fetch(`${config.apiBaseUrl}/api/kiinteistot`, {
            credentials: "include",
          }),
        ]);

        if (!usersResponse.ok || !propertiesResponse.ok) {
          throw new Error("Tietojen lataus epäonnistui");
        }

        const [usersData, propertiesData] = await Promise.all([
          usersResponse.json(),
          propertiesResponse.json(),
        ]);

        setUsers(Array.isArray(usersData) ? usersData : []);
        setKiinteistot(
          Array.isArray(propertiesData) ? propertiesData : []
        );
      } catch (error) {
        console.error("❌ Tietojen lataus epäonnistui:", error);

        setToast({
          show: true,
          message: "❌ Tietojen lataus epäonnistui",
          bg: "danger",
        });
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [canManageUsers, userLoading]);

  const showToast = (message, bg) => {
    setToast({
      show: true,
      message,
      bg,
    });
  };

  const getRoleLabel = (role) =>
    ROLE_OPTIONS.find((option) => option.value === role)?.label ||
    role ||
    "Ei roolia";

  const formatDate = (dateValue) => {
    if (!dateValue) return "–";

    const date = new Date(dateValue);

    if (Number.isNaN(date.getTime())) {
      return dateValue;
    }

    return date.toLocaleDateString("fi-FI");
  };

  // ---------------------------------------------------------------------------
  // USER CREATE
  // ---------------------------------------------------------------------------

  const handleCreateUser = async () => {
    const email = newUser.sahkoposti.trim();

    if (!email) {
      showToast("Sähköposti vaaditaan", "danger");
      return;
    }

    try {
      setCreating(true);

      const response = await fetch(`${config.apiBaseUrl}/api/users`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          ...newUser,
          sahkoposti: email,
        }),
      });

      if (response.status === 409) {
        showToast("⚠️ Käyttäjä on jo olemassa", "warning");
        return;
      }

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Käyttäjän luonti epäonnistui");
      }

      const createdUser = await response.json();

      setUsers((previousUsers) => [...previousUsers, createdUser]);
      setNewUser(EMPTY_NEW_USER);
      setShowAddUserModal(false);
      showToast("✅ Käyttäjä lisätty onnistuneesti!", "success");
    } catch (error) {
      console.error("❌ Käyttäjän luonti epäonnistui:", error);
      showToast("❌ Käyttäjän luonti epäonnistui", "danger");
    } finally {
      setCreating(false);
    }
  };

  // ---------------------------------------------------------------------------
  // USER EDIT
  // ---------------------------------------------------------------------------

 const handleOpenEditModal = async (userToEdit) => {
  setEditingUser({
    ...userToEdit,
    nimi: userToEdit.nimi || "",
    sahkoposti: userToEdit.sahkoposti || "",
    puhelinnumero: userToEdit.puhelinnumero || "",
    ammattinimike: userToEdit.ammattinimike || "",
    yritys: userToEdit.yritys || "",
    osoite: userToEdit.osoite || "",
    postinumero: userToEdit.postinumero || "",
    toimipaikka: userToEdit.toimipaikka || "",
    rooli: userToEdit.rooli || "vieras",
  });

  setDevices([]);
  setEditTab("perustiedot");

  // Clear previous user's data first
  setKoulutukset([]);
  setPatevyydet([]);
  setKielitaidot([]);
  setTyokokemukset([]);
  setReferenssit([]);
  setYritysReferenssit([]);

  setItLaitteet([]);
  setEditingItDevice(null);
  setDeletedKoulutusIds([]);
  setDeletedPatevyysIds([]);
  setDeletedKielitaitoIds([]);
  setDeletedTyokokemusIds([]);
  // Open modal
  setShowEditModal(true);

  try {
    console.log(
      "📥 Ladataan käyttäjän lisätiedot:",
      userToEdit.id
    );
const [
  koulutusData,
  patevyysData,
  kielitaitoData,
  tyokokemusData,
  referenssiData,
  yritysReferenssiData,
] = await Promise.all([
  getKoulutukset(userToEdit.id),
  getPatevyydet(userToEdit.id),
  getKielitaidot(userToEdit.id),
  getTyokokemukset(userToEdit.id),
  getReferenssit(userToEdit.id),
  getYritysReferenssit(),
]);

    console.log("📚 Koulutukset:", koulutusData);
    console.log("🏅 Pätevyydet:", patevyysData);
    console.log("🌍 Kielitaidot:", kielitaitoData);
    console.log("💼 Työkokemukset:", tyokokemusData);

    setKoulutukset(
      Array.isArray(koulutusData)
        ? koulutusData
        : []
    );

    setPatevyydet(
      Array.isArray(patevyysData)
        ? patevyysData
        : []
    );

    setKielitaidot(
      Array.isArray(kielitaitoData)
        ? kielitaitoData
        : []
    );

    setTyokokemukset(
      Array.isArray(tyokokemusData)
        ? tyokokemusData
        : []
    );
    setReferenssit(
  Array.isArray(referenssiData)
    ? referenssiData
    : []
);

setYritysReferenssit(
  Array.isArray(yritysReferenssiData)
    ? yritysReferenssiData
    : []
);
  } catch (error) {
    console.error(
      "❌ Käyttäjän lisätietojen lataus epäonnistui:",
      error
    );

    showToast(
      "❌ Käyttäjän lisätietojen lataus epäonnistui",
      "danger"
    );
  }
};

  const handleCloseEditModal = () => {
    if (savingEdit) return;

    setShowEditModal(false);
    setEditingUser(null);
    setDevices([]);
  };

  const handleEditFieldChange = (field, value) => {
    setEditingUser((previousUser) => {
      if (!previousUser) return previousUser;

      return {
        ...previousUser,
        [field]: value,
      };
    });
  };

const handleSaveEditedUser = async () => {
  if (!editingUser) return;

  const email = editingUser.sahkoposti.trim();

  if (!email) {
    showToast("Sähköposti vaaditaan", "danger");
    return;
  }

  try {
    setSavingEdit(true);

    // ---------------------------------------------------------
    // 1. Käyttäjän perustiedot
    // ---------------------------------------------------------

    const payload = {
      nimi: editingUser.nimi,
      sahkoposti: email,
      puhelinnumero: editingUser.puhelinnumero,
      ammattinimike: editingUser.ammattinimike,
      yritys: editingUser.yritys,
      osoite: editingUser.osoite,
      postinumero: editingUser.postinumero,
      toimipaikka: editingUser.toimipaikka,
      rooli: editingUser.rooli,
    };

    const response = await fetch(
      `${config.apiBaseUrl}/api/users/${editingUser.id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();

      throw new Error(
        errorText || "Käyttäjän muokkaus epäonnistui"
      );
    }

    const responseData = await response.json();

    // ---------------------------------------------------------
    // 2. POISTA RIVIT
    // ---------------------------------------------------------

    console.log("Poistettavat:", {
      deletedKoulutusIds,
      deletedPatevyysIds,
      deletedKielitaitoIds,
      deletedTyokokemusIds,
    });

    await Promise.all([
  ...deletedKoulutusIds.map((id) =>
    deleteKoulutus(id)
  ),

  ...deletedPatevyysIds.map((id) =>
    deletePatevyys(id)
  ),

  ...deletedKielitaitoIds.map((id) =>
    deleteKielitaito(id)
  ),

  ...deletedTyokokemusIds.map((id) =>
    deleteTyokokemus(id)
  ),

  ...deletedReferenssit.map((id) =>
    deleteReferenssi(id)
  ),

  ...deletedYritysReferenssit.map((id) =>
    deleteYritysReferenssi(id)
  ),
]);

    // ---------------------------------------------------------
    // 3. KOULUTUKSET
    // ---------------------------------------------------------

    for (const koulutus of koulutukset) {
      const data = {
        tutkinto: koulutus.tutkinto || "",
        oppilaitos: koulutus.oppilaitos || "",
        valmistumisvuosi:
          koulutus.valmistumisvuosi || null,
      };

      if (koulutus.id) {
        await updateKoulutus(
          koulutus.id,
          data
        );
      } else {
        await createKoulutus(
          editingUser.id,
          data
        );
      }
    }

    // ---------------------------------------------------------
    // 4. PÄTEVYYDET
    // ---------------------------------------------------------

    for (const patevyys of patevyydet) {
      const data = {
        patevyys: patevyys.patevyys || "",
        myontaja: patevyys.myontaja || "",
        suoritusvuosi:
          patevyys.suoritusvuosi || null,
      };

      if (patevyys.id) {
        await updatePatevyys(
          patevyys.id,
          data
        );
      } else {
        await createPatevyys(
          editingUser.id,
          data
        );
      }
    }

    // ---------------------------------------------------------
    // 5. KIELITAIDOT
    // ---------------------------------------------------------

    for (const kielitaito of kielitaidot) {
      const data = {
        kieli: kielitaito.kieli || "",
        taitotaso:
          kielitaito.taitotaso || "Hyvä",
      };

      if (kielitaito.id) {
        await updateKielitaito(
          kielitaito.id,
          data
        );
      } else {
        await createKielitaito(
          editingUser.id,
          data
        );
      }
    }

    // ---------------------------------------------------------
    // 6. TYÖKOKEMUKSET
    // ---------------------------------------------------------

    for (const tyokokemus of tyokokemukset) {
      const data = {
        tyotehtava:
          tyokokemus.tyotehtava || "",

        yritys:
          tyokokemus.yritys || "",

        alkamisvuosi:
          tyokokemus.alkamisvuosi || null,

        paattymisvuosi:
          tyokokemus.paattymisvuosi || null,
      };

      if (tyokokemus.id) {
        await updateTyokokemus(
          tyokokemus.id,
          data
        );
      } else {
        await createTyokokemus(
          editingUser.id,
          data
        );
      }
    }

    // ---------------------------------------------------------
    // 7. Päivitä käyttäjä näkyvään listaan
    // ---------------------------------------------------------
// ---------------------------------------------------------
// 7. HENKILÖN REFERENSSIT
// ---------------------------------------------------------

for (const referenssi of referenssit) {
  const data = {
    kohde: referenssi.kohde || "",
    tilaaja: referenssi.tilaaja || "",
    tuote: referenssi.tuote || "",
    toteutusvuosi:
      referenssi.toteutusvuosi || null,
  };

  if (referenssi.id) {
    await updateReferenssi(
      referenssi.id,
      data
    );
  } else {
    await createReferenssi(
      editingUser.id,
      data
    );
  }
}


// ---------------------------------------------------------
// 8. YRITYKSEN REFERENSSIT
// ---------------------------------------------------------

for (const referenssi of yritysReferenssit) {
  const data = {
    kohde: referenssi.kohde || "",
    tilaaja: referenssi.tilaaja || "",
    tuote: referenssi.tuote || "",
    toteutusvuosi:
      referenssi.toteutusvuosi || null,
  };

  if (referenssi.id) {
    await updateYritysReferenssi(
      referenssi.id,
      data
    );
  } else {
    await createYritysReferenssi(data);
  }
}
    setUsers((previousUsers) =>
      previousUsers.map((user) =>
        user.id === editingUser.id
          ? {
              ...user,
              ...payload,
              ...responseData,
            }
          : user
      )
    );

    // ---------------------------------------------------------
    // 8. Lataa tiedot uudelleen tietokannasta
    // ---------------------------------------------------------

    const [
      koulutusData,
      patevyysData,
      kielitaitoData,
      tyokokemusData,
    ] = await Promise.all([
      getKoulutukset(editingUser.id),
      getPatevyydet(editingUser.id),
      getKielitaidot(editingUser.id),
      getTyokokemukset(editingUser.id),
    ]);

    setKoulutukset(
      Array.isArray(koulutusData)
        ? koulutusData
        : []
    );

    setPatevyydet(
      Array.isArray(patevyysData)
        ? patevyysData
        : []
    );

    setKielitaidot(
      Array.isArray(kielitaitoData)
        ? kielitaitoData
        : []
    );

    setTyokokemukset(
      Array.isArray(tyokokemusData)
        ? tyokokemusData
        : []
    );

    // ---------------------------------------------------------
    // 9. Tyhjennä poistettujen ID:t
    // ---------------------------------------------------------

    setDeletedKoulutusIds([]);
    setDeletedPatevyysIds([]);
    setDeletedKielitaitoIds([]);
    setDeletedTyokokemusIds([]);
    setDeletedReferenssit([]);
    setDeletedYritysReferenssit([]);
    showToast(
      "✅ Käyttäjän tiedot päivitetty!",
      "success"
    );
  } catch (error) {
    console.error(
      "❌ Käyttäjän muokkaus epäonnistui:",
      error
    );

    showToast(
      "❌ Käyttäjän muokkaus epäonnistui",
      "danger"
    );
  } finally {
    setSavingEdit(false);
  }
};

  const handleDeleteUser = async (id, email) => {
    const confirmed = window.confirm(
      `Haluatko varmasti poistaa käyttäjän ${email}?`
    );

    if (!confirmed) return;

    try {
      const response = await fetch(
        `${config.apiBaseUrl}/api/users/${id}`,
        {
          method: "DELETE",
          credentials: "include",
        }
      );

      if (response.status !== 204) {
        const errorText = await response.text();
        throw new Error(errorText || "Käyttäjän poisto epäonnistui");
      }

      setUsers((previousUsers) =>
        previousUsers.filter((user) => user.id !== id)
      );

      if (expandedUserId === id) {
        setExpandedUserId(null);
      }

      showToast("✅ Käyttäjä poistettu", "success");
    } catch (error) {
      console.error("❌ Käyttäjän poisto epäonnistui:", error);
      showToast("❌ Käyttäjän poisto epäonnistui", "danger");
    }
  };

  // ---------------------------------------------------------------------------
  // PROPERTY ASSIGNMENTS
  // ---------------------------------------------------------------------------

  const handleExpand = async (userId) => {
    if (expandedUserId === userId) {
      setExpandedUserId(null);
      return;
    }

    setExpandedUserId(userId);

    if (assignments[userId]) return;

    try {
      const response = await fetch(
        `${config.apiBaseUrl}/api/kayttaja-kiinteistot/user/${userId}`,
        {
          credentials: "include",
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          errorText || "Kiinteistöjen lataus epäonnistui"
        );
      }

      const data = await response.json();

      setAssignments((previousAssignments) => ({
        ...previousAssignments,
        [userId]: Array.isArray(data)
          ? data.map((item) => item.id_kiinteisto)
          : [],
      }));
    } catch (error) {
      console.error("❌ Kiinteistöjen lataus epäonnistui:", error);
      showToast("❌ Kiinteistöjen lataus epäonnistui", "danger");
    }
  };

  const handleKiinteistoToggle = (userId, kiinteistoId) => {
    setAssignments((previousAssignments) => {
      const current = previousAssignments[userId] || [];
      const isSelected = current.includes(kiinteistoId);

      return {
        ...previousAssignments,
        [userId]: isSelected
          ? current.filter((id) => id !== kiinteistoId)
          : [...current, kiinteistoId],
      };
    });
  };

  const handleSaveAssignments = async (userId) => {
    try {
      setSavingAssignmentsUserId(userId);

      const response = await fetch(
        `${config.apiBaseUrl}/api/kayttaja-kiinteistot/user/${userId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            kiinteistoIds: assignments[userId] || [],
          }),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          errorText || "Kiinteistöjen tallennus epäonnistui"
        );
      }

      showToast("✅ Käyttäjän kiinteistöt tallennettu!", "success");
    } catch (error) {
      console.error("❌ Kiinteistöjen tallennus epäonnistui:", error);
      showToast("❌ Kiinteistöjen tallennus epäonnistui", "danger");
    } finally {
      setSavingAssignmentsUserId(null);
    }
  };

  // ---------------------------------------------------------------------------
  // DEVICE MANAGEMENT
  //
  // Backend endpoint assumptions:
  //
  // GET    /api/laitteet?vastuuhenkilo_id=9
  // POST   /api/laitteet
  // PUT    /api/laitteet/:id
  // DELETE /api/laitteet/:id
  //
  // GET    /api/laitteet/:id/huollot
  // POST   /api/laitteet/:id/huollot
  // DELETE /api/laite-huollot/:id
  // ---------------------------------------------------------------------------
const loadItLaitteetForUser = async (userId) => {
  if (!userId) return;

  try {
    setItLaitteetLoading(true);

    const data = await getItLaitteet(userId);

    setItLaitteet(
      Array.isArray(data) ? data : []
    );
  } catch (error) {
    console.error(
      "❌ IT-laitteiden lataus epäonnistui:",
      error
    );

    showToast(
      "❌ IT-laitteiden lataus epäonnistui",
      "danger"
    );
  } finally {
    setItLaitteetLoading(false);
  }
};

const handleAddItDevice = () => {
  setEditingItDevice({
    ...EMPTY_IT_DEVICE,
  });
};

const handleEditItDevice = (device) => {
  setEditingItDevice({
    ...EMPTY_IT_DEVICE,
    ...device,

    hankintapaiva: device.hankintapaiva
      ? String(device.hankintapaiva).slice(0, 10)
      : "",

    leasing_paattymispaiva:
      device.leasing_paattymispaiva
        ? String(
            device.leasing_paattymispaiva
          ).slice(0, 10)
        : "",
  });
};

const handleItDeviceChange = (field, value) => {
  setEditingItDevice((prev) => ({
    ...prev,
    [field]: value,
  }));
};

const handleSaveItDevice = async () => {
  if (!editingUser?.id) return;

  if (!editingItDevice?.laitetyyppi) {
    showToast("Valitse laitetyyppi", "danger");
    return;
  }

  if (!editingItDevice?.merkki_malli?.trim()) {
    showToast("Merkki ja malli vaaditaan", "danger");
    return;
  }

  try {
    setSavingItDevice(true);

    const payload = {
      laitetyyppi: editingItDevice.laitetyyppi,

      merkki_malli:
        editingItDevice.merkki_malli.trim(),

      hankintapaiva:
        editingItDevice.hankintapaiva || null,

      leasing:
        Boolean(editingItDevice.leasing),

      leasing_paattymispaiva:
        editingItDevice.leasing
          ? editingItDevice.leasing_paattymispaiva ||
            null
          : null,
    };

    if (editingItDevice.id) {
      await updateItLaite(
        editingItDevice.id,
        payload
      );
    } else {
      await createItLaite(
        editingUser.id,
        payload
      );
    }

    await loadItLaitteetForUser(editingUser.id);

    setEditingItDevice(null);

    showToast(
      editingItDevice.id
        ? "✅ IT-laitteen tiedot päivitetty"
        : "✅ IT-laite lisätty",
      "success"
    );
  } catch (error) {
    console.error(
      "❌ IT-laitteen tallennus epäonnistui:",
      error
    );

    showToast(
      "❌ IT-laitteen tallennus epäonnistui",
      "danger"
    );
  } finally {
    setSavingItDevice(false);
  }
};

const handleDeleteItDevice = async (device) => {
  const confirmed = window.confirm(
    `Haluatko varmasti poistaa laitteen "${device.merkki_malli}"?`
  );

  if (!confirmed) return;

  try {
    await deleteItLaite(device.id);

    setItLaitteet((prev) =>
      prev.filter(
        (item) => item.id !== device.id
      )
    );

    if (editingItDevice?.id === device.id) {
      setEditingItDevice(null);
    }

    showToast(
      "✅ IT-laite poistettu",
      "success"
    );
  } catch (error) {
    console.error(
      "❌ IT-laitteen poisto epäonnistui:",
      error
    );

    showToast(
      "❌ IT-laitteen poisto epäonnistui",
      "danger"
    );
  }
};
   const loadDevicesForUser = async (userId) => {
  if (!userId) return;

  try {
    setDevicesLoading(true);

    const data = await getLaitteet(userId);

    setDevices(Array.isArray(data) ? data : []);
  } catch (error) {
    console.error("❌ Laitteiden haku epäonnistui:", error);
    showToast("❌ Laitteiden haku epäonnistui", "danger");
    setDevices([]);
  } finally {
    setDevicesLoading(false);
  }
};

const handleChangeEditTab = (tab) => {
  setEditTab(tab);

  if (tab === "laitehallinta" && editingUser?.id) {
    loadDevicesForUser(editingUser.id);
  }

  if (tab === "it-laitteet" && editingUser?.id) {
    loadItLaitteetForUser(editingUser.id);
  }
};

  const handleOpenDeviceModal = async (device = null) => {
    const baseDevice = device
      ? {
          ...EMPTY_DEVICE,
          ...device,
          hankintapaiva: device.hankintapaiva
            ? String(device.hankintapaiva).slice(0, 10)
            : "",
          leasing_paattymispaiva: device.leasing_paattymispaiva
            ? String(device.leasing_paattymispaiva).slice(0, 10)
            : "",
          kalibrointipaiva: device.kalibrointipaiva
            ? String(device.kalibrointipaiva).slice(0, 10)
            : "",
          kalibroinnin_uusintapaiva:
            device.kalibroinnin_uusintapaiva
              ? String(device.kalibroinnin_uusintapaiva).slice(0, 10)
              : "",
        }
      : {
          ...EMPTY_DEVICE,
          vastuuhenkilo_id: editingUser?.id || null,
          varastossa: false,
        };

    setEditingDevice(baseDevice);
    setNewMaintenance(EMPTY_MAINTENANCE);
    setMaintenanceRows([]);
    setShowDeviceModal(true);

    if (device?.id) {
      await loadMaintenance(device.id);
    }
  };

  const handleCloseDeviceModal = () => {
    if (savingDevice || savingMaintenance) return;

    setShowDeviceModal(false);
    setEditingDevice(EMPTY_DEVICE);
    setMaintenanceRows([]);
    setNewMaintenance(EMPTY_MAINTENANCE);
  };

  const handleDeviceFieldChange = (field, value) => {
    setEditingDevice((previousDevice) => ({
      ...previousDevice,
      [field]: value,
    }));
  };

  const handleDeviceOwnerChange = (value) => {
    if (value === "varasto") {
      setEditingDevice((previousDevice) => ({
        ...previousDevice,
        vastuuhenkilo_id: null,
        varastossa: true,
      }));
      return;
    }

    setEditingDevice((previousDevice) => ({
      ...previousDevice,
      vastuuhenkilo_id: value ? Number(value) : null,
      varastossa: false,
    }));
  };

  const handleSaveDevice = async () => {
    if (!editingDevice.laitenimi.trim()) {
      showToast("Laitteen nimi vaaditaan", "danger");
      return;
    }

    try {
      setSavingDevice(true);

      const payload = {
        laitenimi: editingDevice.laitenimi.trim(),
        merkki_malli: editingDevice.merkki_malli,
        hankintapaiva: editingDevice.hankintapaiva || null,

        leasing: Boolean(editingDevice.leasing),
        leasing_paattymispaiva: editingDevice.leasing
          ? editingDevice.leasing_paattymispaiva || null
          : null,

        kalibroitava: Boolean(editingDevice.kalibroitava),
        kalibrointipaiva: editingDevice.kalibroitava
          ? editingDevice.kalibrointipaiva || null
          : null,
        kalibroinnin_uusintapaiva: editingDevice.kalibroitava
          ? editingDevice.kalibroinnin_uusintapaiva || null
          : null,

        vastuuhenkilo_id: editingDevice.varastossa
          ? null
          : editingDevice.vastuuhenkilo_id,
        varastossa: Boolean(editingDevice.varastossa),
      };

      const isUpdate = Boolean(editingDevice.id);

let savedDevice;

if (isUpdate) {
  savedDevice = await updateLaite(
    editingDevice.id,
    payload
  );
} else {
  savedDevice = await createLaite(
    editingUser.id,
    payload
  );
}

setEditingDevice((previousDevice) => ({
  ...previousDevice,
  ...savedDevice,
}));

if (editingUser?.id) {
  await loadDevicesForUser(editingUser.id);
}

showToast(
  isUpdate
    ? "✅ Laitteen tiedot päivitetty!"
    : "✅ Laite lisätty!",
  "success"
);
    } catch (error) {
      console.error("❌ Laitteen tallennus epäonnistui:", error);
      showToast("❌ Laitteen tallennus epäonnistui", "danger");
    } finally {
      setSavingDevice(false);
    }
  };

  const handleDeleteDevice = async (device) => {
  const confirmed = window.confirm(
    `Haluatko varmasti poistaa laitteen "${device.laitenimi}"?`
  );

  if (!confirmed) return;

  try {
    await deleteLaite(device.id);

    setDevices((previousDevices) =>
      previousDevices.filter(
        (item) => item.id !== device.id
      )
    );

    showToast("✅ Laite poistettu", "success");
  } catch (error) {
    console.error("❌ Laitteen poisto epäonnistui:", error);
    showToast("❌ Laitteen poisto epäonnistui", "danger");
  }
};
  const loadMaintenance = async (deviceId) => {
  if (!deviceId) {
    setMaintenanceRows([]);
    return;
  }

  try {
    setMaintenanceLoading(true);

    const data = await getHuollot(deviceId);

    setMaintenanceRows(
      Array.isArray(data) ? data : []
    );
  } catch (error) {
    console.error(
      "❌ Huoltohistorian haku epäonnistui:",
      error
    );

    showToast(
      "❌ Huoltohistorian haku epäonnistui",
      "danger"
    );

    setMaintenanceRows([]);
  } finally {
    setMaintenanceLoading(false);
  }
};
 const handleAddMaintenance = async () => {
  if (!editingDevice?.id) {
    showToast(
      "Tallenna laite ensin ennen huoltohistorian lisäämistä.",
      "warning"
    );
    return;
  }

  if (
    !newMaintenance.paivamaara ||
    !newMaintenance.selite?.trim()
  ) {
    showToast(
      "Huollon päivämäärä ja selite vaaditaan.",
      "danger"
    );
    return;
  }

  try {
    setSavingMaintenance(true);

    // VAIN YKSI POST
    const createdMaintenance = await createHuolto(
      editingDevice.id,
      {
        paivamaara: newMaintenance.paivamaara,
        selite: newMaintenance.selite.trim(),
      }
    );

    setMaintenanceRows((prev) => [
      ...prev,
      createdMaintenance,
    ]);

    setNewMaintenance(EMPTY_MAINTENANCE);

    showToast("✅ Huolto lisätty", "success");
  } catch (error) {
    console.error("❌ Huollon lisäys epäonnistui:", error);

    showToast(
      "❌ Huollon lisäys epäonnistui",
      "danger"
    );
  } finally {
    setSavingMaintenance(false);
  }
};

  const handleDeleteMaintenance = async (maintenanceId) => {
  const confirmed = window.confirm(
    "Haluatko varmasti poistaa tämän huoltohistorian rivin?"
  );

  if (!confirmed) return;

  try {
    await deleteHuolto(maintenanceId);

    setMaintenanceRows((prev) =>
      prev.filter((row) => row.id !== maintenanceId)
    );

    showToast(
      "✅ Huoltohistorian rivi poistettu",
      "success"
    );
  } catch (error) {
    console.error(
      "❌ Huoltohistorian poisto epäonnistui:",
      error
    );

    showToast(
      "❌ Huoltohistorian poisto epäonnistui",
      "danger"
    );
  }
};
  // ---------------------------------------------------------------------------
  // FILTERED USERS
  // ---------------------------------------------------------------------------

  const filteredUsers = useMemo(() => {
    return users.filter((user) => {
      const matchesRole =
        roleFilter === "all" || user.rooli === roleFilter;

      const term = userSearch.trim().toLowerCase();

      if (!term) return matchesRole;

      const matchesSearch = [
        user.nimi,
        user.sahkoposti,
        user.ammattinimike,
        user.puhelinnumero,
        user.yritys,
        user.osoite,
        user.postinumero,
        user.toimipaikka,
      ].some((value) =>
        String(value || "")
          .toLowerCase()
          .includes(term)
      );

      return matchesRole && matchesSearch;
    });
  }, [users, roleFilter, userSearch]);

  // ---------------------------------------------------------------------------
  // LOADING / ACCESS
  // ---------------------------------------------------------------------------

  if (userLoading || loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
        <div className="mt-2">Ladataan käyttäjiä...</div>
      </Container>
    );
  }

  if (!canManageUsers) {
    return (
      <Container className="mt-5 text-center">
        <h4>Ei käyttöoikeutta</h4>
        <p>Sinulla ei ole oikeutta hallita käyttäjiä.</p>
      </Container>
    );
  }

  return (
    <Container className="mt-5">
      {/* ------------------------------------------------------------------ */}
      {/* ADD USER */}
      {/* ------------------------------------------------------------------ */}

    

      <div className="mb-3 text-end">
        <Button
          variant="outline-secondary"
          onClick={() => {
            window.location.href = "/profile";
          }}
        >
          ← Takaisin profiiliin
        </Button>
      </div>

      {/* ------------------------------------------------------------------ */}
      {/* USERS */}
      {/* ------------------------------------------------------------------ */}

     <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
  <div className="d-flex align-items-center gap-2">
    <h5 className="mb-0 text-primary">Käyttäjät</h5>

    <Button
      size="sm"
      onClick={() => setShowAddUserModal(true)}
      style={{
        backgroundColor: "#04aa00",
        borderColor: "#04aa00",
        borderRadius: "8px",
        fontWeight: "600",
      }}
    >
      + Lisää käyttäjä
    </Button>
  </div>

  <div className="d-flex gap-2 flex-wrap">
    <Form.Control
      type="text"
      placeholder="Etsi käyttäjää..."
      value={userSearch}
      onChange={(event) => setUserSearch(event.target.value)}
      style={{ maxWidth: "220px" }}
    />

    <Form.Select
      style={{ maxWidth: "200px" }}
      value={roleFilter}
      onChange={(event) => setRoleFilter(event.target.value)}
    >
      <option value="all">Kaikki roolit</option>

      {ROLE_OPTIONS.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Form.Select>
  </div>
</div>

      <div className="row g-3">
        {filteredUsers.map((user) => {
          const userAssignments = assignments[user.id];
          const propertySearch = (
            searchTerms[user.id] || ""
          ).toLowerCase();

          const filteredProperties = kiinteistot.filter((property) => {
            const label =
              property.kohteen_nimi ||
              property.kiinteistotunnus ||
              "";

            return label.toLowerCase().includes(propertySearch);
          });

          return (
            <div key={user.id} className="col-12 col-md-6 col-lg-4">
              <div
                className="card h-100 shadow-sm"
                style={{
                  borderRadius: "16px",
                  borderTop: "5px solid #04aa00",
                  borderLeft: "1px solid #d9f5d9",
                  borderRight: "1px solid #d9f5d9",
                  borderBottom: "1px solid #d9f5d9",
                  backgroundColor: "#fcfffc",
                }}
              >
                <div
                  className="card-body d-flex flex-column"
                  style={{
                    background:
                      "linear-gradient(to bottom, #f8fff8 0%, #ffffff 25%)",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-start mb-2 gap-2">
                    <div className="text-break">
                      <h6 className="mb-0">{user.nimi || "–"}</h6>
                      <small className="text-muted">
                        {user.sahkoposti || "–"}
                      </small>
                    </div>

                    <div className="d-flex gap-1 flex-shrink-0">
                      <Button
                        size="sm"
                        variant="outline-success"
                        onClick={() => handleOpenEditModal(user)}
                      >
                        Muokkaa
                      </Button>

                      <Button
                        size="sm"
                        variant="danger"
                        onClick={() =>
                          handleDeleteUser(user.id, user.sahkoposti)
                        }
                      >
                        Poista
                      </Button>
                    </div>
                  </div>

                  <div className="mb-2 small">
                    <div>
                      <strong>📞</strong>{" "}
                      {user.puhelinnumero || "–"}
                    </div>

                    <div>
                      <strong>💼</strong>{" "}
                      {user.ammattinimike || "–"}
                    </div>

                    <div>
                      <strong>🏢</strong> {user.yritys || "–"}
                    </div>
                  </div>

                  <div className="mb-2">
                    <span
                      className="badge"
                      style={{
                        backgroundColor: "#04aa00",
                        color: "#fff",
                        padding: "7px 10px",
                      }}
                    >
                      {getRoleLabel(user.rooli)}
                    </span>
                  </div>

                  {user.rooli === "vieras" && (
                    <div className="mb-2">
                      <Button
                        size="sm"
                        variant="outline-success"
                        className="w-100 mb-2"
                        onClick={() => handleExpand(user.id)}
                      >
                        {expandedUserId === user.id
                          ? "Piilota kiinteistöt"
                          : "Näytä kiinteistöt"}
                      </Button>

                      {expandedUserId === user.id && (
                        <div
                          className="border rounded p-2 bg-light"
                          style={{
                            maxHeight: "260px",
                            overflowY: "auto",
                          }}
                        >
                          <Form.Control
                            size="sm"
                            placeholder="Etsi kiinteistöä..."
                            className="mb-2"
                            value={searchTerms[user.id] || ""}
                            onChange={(event) =>
                              setSearchTerms((previousTerms) => ({
                                ...previousTerms,
                                [user.id]: event.target.value,
                              }))
                            }
                          />

                          {!userAssignments ? (
                            <div className="text-center py-2">
                              <Spinner animation="border" size="sm" />
                            </div>
                          ) : (
                            <>
                              {filteredProperties.map((property) => {
                                const checked = userAssignments.includes(
                                  property.id_kiinteisto
                                );

                                return (
                                  <div
                                    key={property.id_kiinteisto}
                                    className={`p-2 mb-2 border rounded ${
                                      checked
                                        ? "bg-success bg-opacity-10"
                                        : "bg-white"
                                    }`}
                                    onClick={() =>
                                      handleKiinteistoToggle(
                                        user.id,
                                        property.id_kiinteisto
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <Form.Check
                                      checked={checked}
                                      readOnly
                                      label={
                                        property.kohteen_nimi ||
                                        property.kiinteistotunnus
                                      }
                                    />
                                  </div>
                                );
                              })}

                              <Button
                                size="sm"
                                variant="success"
                                className="w-100"
                                disabled={
                                  savingAssignmentsUserId === user.id
                                }
                                onClick={() =>
                                  handleSaveAssignments(user.id)
                                }
                              >
                                {savingAssignmentsUserId === user.id
                                  ? "Tallennetaan..."
                                  : "Tallenna kiinteistöt"}
                              </Button>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  )}

                  <div className="mt-auto" />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {filteredUsers.length === 0 && (
        <div className="text-center text-muted py-5">
          Käyttäjiä ei löytynyt.
        </div>
      )}
{/* ------------------------------------------------------------------ */}
{/* ADD USER MODAL */}
{/* ------------------------------------------------------------------ */}

<Modal
  show={showAddUserModal}
  onHide={() => {
    if (!creating) {
      setShowAddUserModal(false);
    }
  }}
  centered
  size="lg"
  backdrop={creating ? "static" : true}
  keyboard={!creating}
  contentClassName="border-0 shadow"
>
  <Modal.Header
    closeButton={!creating}
    style={{
      background: "linear-gradient(135deg, #04aa00, #028a00)",
      color: "#fff",
      borderBottom: "none",
      padding: "18px 22px",
    }}
  >
    <div>
      <Modal.Title className="fw-bold mb-1">
        Lisää uusi käyttäjä
      </Modal.Title>

      <small style={{ opacity: 0.9 }}>
        Täytä käyttäjän perustiedot ja valitse rooli
      </small>
    </div>
  </Modal.Header>

  <Modal.Body
    style={{
      backgroundColor: "#f8fff8",
      padding: "24px",
    }}
  >
    <div className="row g-3">
      <div className="col-md-6">
        <Form.Group>
          <Form.Label className="fw-semibold">
            Nimi
          </Form.Label>

          <Form.Control
            type="text"
            placeholder="Esimerkiksi Matti Meikäläinen"
            value={newUser.nimi}
            onChange={(event) =>
              setNewUser((previousUser) => ({
                ...previousUser,
                nimi: event.target.value,
              }))
            }
            style={{
              borderColor: "#bfe8bf",
              borderRadius: "10px",
            }}
          />
        </Form.Group>
      </div>

      <div className="col-md-6">
        <Form.Group>
          <Form.Label className="fw-semibold">
            Sähköposti
          </Form.Label>

          <Form.Control
            type="email"
            placeholder="nimi@yritys.fi"
            value={newUser.sahkoposti}
            onChange={(event) =>
              setNewUser((previousUser) => ({
                ...previousUser,
                sahkoposti: event.target.value,
              }))
            }
            style={{
              borderColor: "#bfe8bf",
              borderRadius: "10px",
            }}
          />
        </Form.Group>
      </div>

      <div className="col-md-6">
        <Form.Group>
          <Form.Label className="fw-semibold">
            Puhelinnumero
          </Form.Label>

          <Form.Control
            type="text"
            placeholder="040 123 4567"
            value={newUser.puhelinnumero}
            onChange={(event) =>
              setNewUser((previousUser) => ({
                ...previousUser,
                puhelinnumero: event.target.value,
              }))
            }
            style={{
              borderColor: "#bfe8bf",
              borderRadius: "10px",
            }}
          />
        </Form.Group>
      </div>

      <div className="col-md-6">
        <Form.Group>
          <Form.Label className="fw-semibold">
            Ammattinimike
          </Form.Label>

          <Form.Control
            type="text"
            placeholder="Esimerkiksi projektipäällikkö"
            value={newUser.ammattinimike}
            onChange={(event) =>
              setNewUser((previousUser) => ({
                ...previousUser,
                ammattinimike: event.target.value,
              }))
            }
            style={{
              borderColor: "#bfe8bf",
              borderRadius: "10px",
            }}
          />
        </Form.Group>
      </div>

      <div className="col-md-8">
        <Form.Group>
          <Form.Label className="fw-semibold">
            Yritys
          </Form.Label>

          <Form.Control
            type="text"
            placeholder="Yrityksen nimi"
            value={newUser.yritys}
            onChange={(event) =>
              setNewUser((previousUser) => ({
                ...previousUser,
                yritys: event.target.value,
              }))
            }
            style={{
              borderColor: "#bfe8bf",
              borderRadius: "10px",
            }}
          />
        </Form.Group>
      </div>

      <div className="col-md-4">
        <Form.Group>
          <Form.Label className="fw-semibold">
            Rooli
          </Form.Label>

          <Form.Select
            value={newUser.rooli}
            onChange={(event) =>
              setNewUser((previousUser) => ({
                ...previousUser,
                rooli: event.target.value,
              }))
            }
            style={{
              borderColor: "#bfe8bf",
              borderRadius: "10px",
            }}
          >
            {ROLE_OPTIONS.map((option) => (
              <option
                key={option.value}
                value={option.value}
              >
                {option.label}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </div>

      <div className="col-12">
        <hr className="my-2" />
      </div>

      <div className="col-md-6">
        <Form.Group>
          <Form.Label className="fw-semibold">
            Osoite
          </Form.Label>

          <Form.Control
            placeholder="Katuosoite 1"
            value={newUser.osoite}
            onChange={(event) =>
              setNewUser((previousUser) => ({
                ...previousUser,
                osoite: event.target.value,
              }))
            }
            style={{
              borderColor: "#bfe8bf",
              borderRadius: "10px",
            }}
          />
        </Form.Group>
      </div>

      <div className="col-md-2">
        <Form.Group>
          <Form.Label className="fw-semibold">
            Postinumero
          </Form.Label>

          <Form.Control
            placeholder="90100"
            value={newUser.postinumero}
            onChange={(event) =>
              setNewUser((previousUser) => ({
                ...previousUser,
                postinumero: event.target.value,
              }))
            }
            style={{
              borderColor: "#bfe8bf",
              borderRadius: "10px",
            }}
          />
        </Form.Group>
      </div>

      <div className="col-md-4">
        <Form.Group>
          <Form.Label className="fw-semibold">
            Toimipaikka
          </Form.Label>

          <Form.Control
            placeholder="Oulu"
            value={newUser.toimipaikka}
            onChange={(event) =>
              setNewUser((previousUser) => ({
                ...previousUser,
                toimipaikka: event.target.value,
              }))
            }
            style={{
              borderColor: "#bfe8bf",
              borderRadius: "10px",
            }}
          />
        </Form.Group>
      </div>
    </div>
  </Modal.Body>

  <Modal.Footer>
    <Button
      variant="outline-secondary"
      disabled={creating}
      onClick={() => setShowAddUserModal(false)}
    >
      Peruuta
    </Button>

    <Button
      disabled={creating}
      onClick={handleCreateUser}
      style={{
        backgroundColor: "#04aa00",
        borderColor: "#04aa00",
        minWidth: "150px",
        fontWeight: "600",
      }}
    >
      {creating ? (
        <>
          <Spinner
            animation="border"
            size="sm"
            className="me-2"
          />
          Lisätään...
        </>
      ) : (
        "Lisää käyttäjä"
      )}
    </Button>
  </Modal.Footer>
</Modal>
      {/* ------------------------------------------------------------------ */}
      {/* USER EDIT MODAL */}
      {/* ------------------------------------------------------------------ */}

      <Modal
        show={showEditModal}
        onHide={handleCloseEditModal}
        centered
        backdrop={savingEdit ? "static" : true}
        keyboard={!savingEdit}
        size="lg"
        contentClassName="border-0 shadow"
      >
        <Modal.Header
          closeButton={!savingEdit}
          style={{
            background:
              "linear-gradient(135deg, #04aa00, #028a00)",
            color: "#fff",
            borderBottom: "none",
            padding: "18px 22px",
          }}
        >
          <div>
            <Modal.Title className="fw-bold mb-1">
              Muokkaa käyttäjää
            </Modal.Title>

            <small style={{ opacity: 0.9 }}>
              Päivitä käyttäjän tiedot ja hallitse tutkimuskalustoa
            </small>
          </div>
        </Modal.Header>

        <Modal.Body
          style={{
            backgroundColor: "#f8fff8",
            padding: "24px",
          }}
        >
          {editingUser && (
            <>
              <div
                className="mb-4 p-3 rounded"
                style={{
                  backgroundColor: "#ffffff",
                  border: "1px solid #d9f5d9",
                  boxShadow:
                    "0 3px 10px rgba(4, 170, 0, 0.08)",
                }}
              >
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="d-flex align-items-center justify-content-center fw-bold text-white"
                    style={{
                      width: "52px",
                      height: "52px",
                      borderRadius: "50%",
                      backgroundColor: "#04aa00",
                      fontSize: "1.2rem",
                    }}
                  >
                    {(
                      editingUser.nimi ||
                      editingUser.sahkoposti ||
                      "?"
                    )
                      .charAt(0)
                      .toUpperCase()}
                  </div>

                  <div className="text-break">
                    <div className="fw-bold">
                      {editingUser.nimi || "Nimetön käyttäjä"}
                    </div>
                    <small className="text-muted">
                      {editingUser.sahkoposti || "Ei sähköpostia"}
                    </small>
                  </div>
                </div>
              </div>

              <div
                className="d-flex gap-2 mb-4 p-1 rounded flex-wrap"
                style={{
                  backgroundColor: "#eaf7ea",
                  width: "fit-content",
                }}
              >
               {[
                  ["perustiedot", "Perustiedot"],
                  ["osoite", "Osoite"],
                  ["koulutus", "Koulutus"],
                  ["patevyydet", "Pätevyydet"],
                  ["kielitaito", "Kielitaito"],
                  ["tyokokemus", "Työkokemus"],
                  ["referenssit", "Referenssit"],
                  ["laitehallinta", "Laitehallinta"],
                  ["it-laitteet", "IT-laitteet"],
                  ["kayttooikeudet", "Käyttöoikeudet"],
                ].map(([key, label]) => (
                  <Button
                    key={key}
                    size="sm"
                    onClick={() => handleChangeEditTab(key)}
                    style={{
                      backgroundColor:
                        editTab === key
                          ? "#04aa00"
                          : "transparent",
                      borderColor:
                        editTab === key
                          ? "#04aa00"
                          : "transparent",
                      color:
                        editTab === key
                          ? "#ffffff"
                          : "#356535",
                      borderRadius: "8px",
                    }}
                  >
                    {label}
                  </Button>
                ))}
              </div>

              {editTab === "perustiedot" && (
                <div className="row g-3">
                  <div className="col-md-6">
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Nimi
                      </Form.Label>
                      <Form.Control
                        value={editingUser.nimi}
                        onChange={(event) =>
                          handleEditFieldChange(
                            "nimi",
                            event.target.value
                          )
                        }
                        style={{ borderColor: "#bfe8bf" }}
                      />
                    </Form.Group>
                  </div>

                  <div className="col-md-6">
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Sähköposti
                      </Form.Label>
                      <Form.Control
                        type="email"
                        value={editingUser.sahkoposti}
                        onChange={(event) =>
                          handleEditFieldChange(
                            "sahkoposti",
                            event.target.value
                          )
                        }
                        style={{ borderColor: "#bfe8bf" }}
                      />
                    </Form.Group>
                  </div>

                  <div className="col-md-6">
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Puhelinnumero
                      </Form.Label>
                      <Form.Control
                        value={editingUser.puhelinnumero}
                        onChange={(event) =>
                          handleEditFieldChange(
                            "puhelinnumero",
                            event.target.value
                          )
                        }
                        style={{ borderColor: "#bfe8bf" }}
                      />
                    </Form.Group>
                  </div>

                  <div className="col-md-6">
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Ammattinimike
                      </Form.Label>
                      <Form.Control
                        value={editingUser.ammattinimike}
                        onChange={(event) =>
                          handleEditFieldChange(
                            "ammattinimike",
                            event.target.value
                          )
                        }
                        style={{ borderColor: "#bfe8bf" }}
                      />
                    </Form.Group>
                  </div>

                  <div className="col-12">
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Yritys
                      </Form.Label>
                      <Form.Control
                        value={editingUser.yritys}
                        onChange={(event) =>
                          handleEditFieldChange(
                            "yritys",
                            event.target.value
                          )
                        }
                        style={{ borderColor: "#bfe8bf" }}
                      />
                    </Form.Group>
                  </div>
                </div>
              )}

              {editTab === "osoite" && (
                <div className="row g-3">
                  <div className="col-12">
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Osoite
                      </Form.Label>
                      <Form.Control
                        value={editingUser.osoite || ""}
                        onChange={(event) =>
                          handleEditFieldChange(
                            "osoite",
                            event.target.value
                          )
                        }
                        style={{ borderColor: "#bfe8bf" }}
                      />
                    </Form.Group>
                  </div>

                  <div className="col-md-4">
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Postinumero
                      </Form.Label>
                      <Form.Control
                        value={editingUser.postinumero || ""}
                        onChange={(event) =>
                          handleEditFieldChange(
                            "postinumero",
                            event.target.value
                          )
                        }
                        style={{ borderColor: "#bfe8bf" }}
                      />
                    </Form.Group>
                  </div>

                  <div className="col-md-8">
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Toimipaikka
                      </Form.Label>
                      <Form.Control
                        value={editingUser.toimipaikka || ""}
                        onChange={(event) =>
                          handleEditFieldChange(
                            "toimipaikka",
                            event.target.value
                          )
                        }
                        style={{ borderColor: "#bfe8bf" }}
                      />
                    </Form.Group>
                  </div>
                </div>
              )}

              {editTab === "laitehallinta" && (
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                    <div>
                      <h6 className="mb-1 fw-bold">
                        Tutkimuskalusto
                      </h6>
                      <small className="text-muted">
                        Käyttäjälle osoitetut laitteet
                      </small>
                    </div>

                    <Button
                      size="sm"
                      onClick={() => handleOpenDeviceModal()}
                      style={{
                        backgroundColor: "#04aa00",
                        borderColor: "#04aa00",
                      }}
                    >
                      + Lisää laite
                    </Button>
                  </div>

                  {devicesLoading ? (
                    <div className="text-center py-4">
                      <Spinner animation="border" size="sm" />
                      <div className="small text-muted mt-2">
                        Ladataan laitteita...
                      </div>
                    </div>
                  ) : devices.length === 0 ? (
                    <div
                      className="text-center p-4 rounded"
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px dashed #bfe8bf",
                      }}
                    >
                      <div className="fw-semibold mb-1">
                        Ei osoitettuja laitteita
                      </div>
                      <small className="text-muted">
                        Lisää käyttäjälle tutkimuskalustoa
                        painamalla Lisää laite.
                      </small>
                    </div>
                  ) : (
                    <div className="d-flex flex-column gap-2">
                      {devices.map((device) => (
                        <div
                          key={device.id}
                          className="p-3 rounded"
                          style={{
                            backgroundColor: "#ffffff",
                            border: "1px solid #d9f5d9",
                          }}
                        >
                          <div className="d-flex justify-content-between gap-3">
                            <div>
                              <div className="fw-bold">
                                {device.laitenimi}
                              </div>

                              <div className="small text-muted">
                                {device.merkki_malli || "Ei merkkiä/mallia"}
                              </div>

                              <div className="small mt-2">
                                <span className="me-3">
                                  Hankittu:{" "}
                                  <strong>
                                    {formatDate(
                                      device.hankintapaiva
                                    )}
                                  </strong>
                                </span>

                                {device.leasing && (
                                  <span className="badge bg-info text-dark me-2">
                                    Leasing
                                  </span>
                                )}

                                {device.kalibroitava && (
                                  <span className="badge bg-warning text-dark">
                                    Kalibroitava
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="d-flex gap-1 align-items-start">
                              <Button
                                size="sm"
                                variant="outline-success"
                                onClick={() =>
                                  handleOpenDeviceModal(device)
                                }
                              >
                                Muokkaa
                              </Button>

                              <Button
                                size="sm"
                                variant="outline-danger"
                                onClick={() =>
                                  handleDeleteDevice(device)
                                }
                              >
                                Poista
                              </Button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
                {editTab === "koulutus" && (
  <div>
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h6 className="mb-1 fw-bold">Koulutus</h6>
        <small className="text-muted">
          Käyttäjän tutkinnot ja koulutustausta
        </small>
      </div>

      <Button
        size="sm"
        style={{
          backgroundColor: "#04aa00",
          borderColor: "#04aa00",
        }}
        onClick={() =>
          setKoulutukset((prev) => [
            ...prev,
            {
              tutkinto: "",
              oppilaitos: "",
              valmistumisvuosi: "",
            },
          ])
        }
      >
        + Lisää koulutus
      </Button>
    </div>

    {koulutukset.length === 0 ? (
      <div
        className="text-center p-4 rounded"
        style={{
          backgroundColor: "#fff",
          border: "1px dashed #bfe8bf",
        }}
      >
        <small className="text-muted">
          Koulutuksia ei ole lisätty.
        </small>
      </div>
    ) : (
      koulutukset.map((item, index) => (
        <div
          key={item.id || index}
          className="p-3 rounded mb-2"
          style={{
            backgroundColor: "#fff",
            border: "1px solid #d9f5d9",
          }}
        >
          <div className="row g-2">
            <div className="col-md-4">
              <Form.Label className="fw-semibold">
                Tutkinto
              </Form.Label>

              <Form.Control
                value={item.tutkinto}
                onChange={(e) =>
                  setKoulutukset((prev) =>
                    prev.map((row, i) =>
                      i === index
                        ? {
                            ...row,
                            tutkinto: e.target.value,
                          }
                        : row
                    )
                  )
                }
              />
            </div>

            <div className="col-md-4">
              <Form.Label className="fw-semibold">
                Oppilaitos
              </Form.Label>

              <Form.Control
                value={item.oppilaitos}
                onChange={(e) =>
                  setKoulutukset((prev) =>
                    prev.map((row, i) =>
                      i === index
                        ? {
                            ...row,
                            oppilaitos: e.target.value,
                          }
                        : row
                    )
                  )
                }
              />
            </div>

            <div className="col-md-3">
              <Form.Label className="fw-semibold">
                Valmistumisvuosi
              </Form.Label>

              <Form.Control
                type="number"
                value={item.valmistumisvuosi}
                onChange={(e) =>
                  setKoulutukset((prev) =>
                    prev.map((row, i) =>
                      i === index
                        ? {
                            ...row,
                            valmistumisvuosi:
                              e.target.value,
                          }
                        : row
                    )
                  )
                }
              />
            </div>

            <div className="col-md-1 d-flex align-items-end">
              <Button
  type="button" 
  variant="outline-danger"
  onClick={() => {
    if (item.id) {
      setDeletedKoulutusIds((prev) => [
        ...prev,
        item.id,
      ]);
    }

    setKoulutukset((prev) =>
      prev.filter((_, i) => i !== index)
    );
  }}
>
  ×
</Button>
            </div>
          </div>
        </div>
      ))
    )}
  </div>
)}

{editTab === "it-laitteet" && (
  <div>
    <div className="d-flex justify-content-between align-items-center mb-4">
      <div>
        <h6 className="mb-1 fw-bold">
          IT-laitteet
        </h6>

        <small className="text-muted">
          Käyttäjälle osoitetut puhelimet,
          tietokoneet ja muut IT-laitteet
        </small>
      </div>

      <Button
        type="button"
        size="sm"
        onClick={handleAddItDevice}
        style={{
          backgroundColor: "#04aa00",
          borderColor: "#04aa00",
          borderRadius: "8px",
        }}
      >
        + Lisää IT-laite
      </Button>
    </div>

    {itLaitteetLoading ? (
      <div className="text-center py-5">
        <Spinner animation="border" />
      </div>
    ) : itLaitteet.length === 0 ? (
      <div
        className="text-center text-muted py-5"
        style={{
          backgroundColor: "#fafcfa",
          border: "1px dashed #cddacd",
          borderRadius: "12px",
        }}
      >
        Ei lisättyjä IT-laitteita.
      </div>
    ) : (
      <div className="d-flex flex-column gap-3">
        {itLaitteet.map((device, index) => (
          <div
            key={
              device.id ||
              `it-laite-${index}`
            }
            style={{
              border: "1px solid #e3e9e3",
              borderLeft:
                "5px solid #04aa00",
              borderRadius: "12px",
              backgroundColor: "#ffffff",
              boxShadow:
                "0 3px 10px rgba(0,0,0,0.06)",
              overflow: "hidden",
            }}
          >
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                padding: "12px 16px",
                backgroundColor: "#f7fbf7",
                borderBottom:
                  "1px solid #e7ece7",
              }}
            >
              <div className="d-flex align-items-center gap-3">
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    backgroundColor:
                      "#04aa00",
                    color: "#ffffff",
                    fontWeight: "700",
                    fontSize: "13px",
                  }}
                >
                  {index + 1}
                </div>

                <div>
                  <div
                    className="fw-semibold"
                    style={{
                      color: "#315b31",
                    }}
                  >
                    {device.merkki_malli ||
                      "IT-laite"}
                  </div>

                  <div
                    className="text-muted"
                    style={{
                      fontSize: "12px",
                    }}
                  >
                    {device.laitetyyppi ||
                      "Laitetyyppiä ei määritetty"}
                  </div>
                </div>
              </div>

              <div className="d-flex gap-2">
                <Button
                  type="button"
                  size="sm"
                  variant="outline-secondary"
                  onClick={() =>
                    handleEditItDevice(device)
                  }
                >
                  Muokkaa
                </Button>

                <Button
                  type="button"
                  size="sm"
                  variant="outline-danger"
                  onClick={() =>
                    handleDeleteItDevice(device)
                  }
                >
                  Poista
                </Button>
              </div>
            </div>

            <div
              style={{ padding: "16px" }}
            >
              <div className="row g-3">
                <div className="col-md-4">
                  <div
                    className="text-muted fw-semibold"
                    style={{
                      fontSize: "12px",
                    }}
                  >
                    Laitetyyppi
                  </div>

                  <div>
                    {device.laitetyyppi ||
                      "–"}
                  </div>
                </div>

                <div className="col-md-4">
                  <div
                    className="text-muted fw-semibold"
                    style={{
                      fontSize: "12px",
                    }}
                  >
                    Merkki ja malli
                  </div>

                  <div>
                    {device.merkki_malli ||
                      "–"}
                  </div>
                </div>

                <div className="col-md-4">
                  <div
                    className="text-muted fw-semibold"
                    style={{
                      fontSize: "12px",
                    }}
                  >
                    Hankintapäivä
                  </div>

                  <div>
                    {device.hankintapaiva
                      ? new Date(
                          device.hankintapaiva
                        ).toLocaleDateString(
                          "fi-FI"
                        )
                      : "–"}
                  </div>
                </div>

                <div className="col-md-4">
                  <div
                    className="text-muted fw-semibold"
                    style={{
                      fontSize: "12px",
                    }}
                  >
                    Leasing
                  </div>

                  <div>
                    {device.leasing
                      ? "Kyllä"
                      : "Ei"}
                  </div>
                </div>

                {device.leasing && (
                  <div className="col-md-4">
                    <div
                      className="text-muted fw-semibold"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      Leasing päättyy
                    </div>

                    <div>
                      {device.leasing_paattymispaiva
                        ? new Date(
                            device.leasing_paattymispaiva
                          ).toLocaleDateString(
                            "fi-FI"
                          )
                        : "–"}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    )}

    {editingItDevice && (
      <div
        className="mt-4"
        style={{
          border: "1px solid #dce7dc",
          borderLeft:
            "5px solid #04aa00",
          borderRadius: "12px",
          backgroundColor: "#f7fbf7",
          padding: "20px",
        }}
      >
        <h6
          className="mb-3 fw-bold"
          style={{
            color: "#264d26",
          }}
        >
          {editingItDevice.id
            ? "Muokkaa IT-laitetta"
            : "Lisää IT-laite"}
        </h6>

        <div className="row g-3">
          <div className="col-md-6">
            <Form.Group>
              <Form.Label className="fw-semibold small">
                Laitetyyppi
              </Form.Label>

              <Form.Select
                value={
                  editingItDevice.laitetyyppi ||
                  ""
                }
                onChange={(e) =>
                  handleItDeviceChange(
                    "laitetyyppi",
                    e.target.value
                  )
                }
              >
                <option value="">
                  Valitse laitetyyppi
                </option>

                <option value="Kannettava tietokone">
                  Kannettava tietokone
                </option>

                <option value="Puhelin">
                  Puhelin
                </option>

                <option value="Tabletti">
                  Tabletti
                </option>

                <option value="Pöytätietokone">
                  Pöytätietokone
                </option>

                <option value="Muu">
                  Muu
                </option>
              </Form.Select>
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group>
              <Form.Label className="fw-semibold small">
                Merkki ja malli
              </Form.Label>

              <Form.Control
                value={
                  editingItDevice.merkki_malli ||
                  ""
                }
                onChange={(e) =>
                  handleItDeviceChange(
                    "merkki_malli",
                    e.target.value
                  )
                }
              />
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group>
              <Form.Label className="fw-semibold small">
                Hankintapäivä
              </Form.Label>

              <Form.Control
                type="date"
                value={
                  editingItDevice.hankintapaiva ||
                  ""
                }
                onChange={(e) =>
                  handleItDeviceChange(
                    "hankintapaiva",
                    e.target.value
                  )
                }
              />
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group>
              <Form.Label className="fw-semibold small d-block">
                Leasing
              </Form.Label>

              <Form.Check
                type="switch"
                checked={Boolean(
                  editingItDevice.leasing
                )}
                label={
                  editingItDevice.leasing
                    ? "Kyllä"
                    : "Ei"
                }
                onChange={(e) =>
                  handleItDeviceChange(
                    "leasing",
                    e.target.checked
                  )
                }
              />
            </Form.Group>
          </div>

          {editingItDevice.leasing && (
            <div className="col-md-6">
              <Form.Group>
                <Form.Label className="fw-semibold small">
                  Leasing päättymispäivä
                </Form.Label>

                <Form.Control
                  type="date"
                  value={
                    editingItDevice.leasing_paattymispaiva ||
                    ""
                  }
                  onChange={(e) =>
                    handleItDeviceChange(
                      "leasing_paattymispaiva",
                      e.target.value
                    )
                  }
                />
              </Form.Group>
            </div>
          )}
        </div>

        <div className="d-flex justify-content-end gap-2 mt-4">
          <Button
            type="button"
            variant="outline-secondary"
            onClick={() =>
              setEditingItDevice(null)
            }
          >
            Peruuta
          </Button>

          <Button
            type="button"
            disabled={savingItDevice}
            onClick={handleSaveItDevice}
            style={{
              backgroundColor: "#04aa00",
              borderColor: "#04aa00",
            }}
          >
            {savingItDevice
              ? "Tallennetaan..."
              : "Tallenna"}
          </Button>
        </div>
      </div>
    )}
  </div>
)}
{editTab === "referenssit" && (
  <div>
    <div className="d-flex justify-content-between align-items-center mb-4">
      <div>
        <h6 className="mb-1 fw-bold">
          Henkilön referenssikohteet
        </h6>

        <small className="text-muted">
          Käyttäjän omat referenssikohteet
        </small>
      </div>

      <Button
        type="button"
        size="sm"
        onClick={() =>
          setReferenssit((prev) => [
            ...prev,
            {
              kohde: "",
              tilaaja: "",
              tuote: "",
              toteutusvuosi: "",
            },
          ])
        }
        style={{
          backgroundColor: "#04aa00",
          borderColor: "#04aa00",
          borderRadius: "8px",
        }}
      >
        + Lisää referenssi
      </Button>
    </div>

    {referenssit.length === 0 ? (
      <div
        className="text-center text-muted py-5"
        style={{
          backgroundColor: "#fafcfa",
          border: "1px dashed #cddacd",
          borderRadius: "12px",
        }}
      >
        Ei lisättyjä referenssejä.
      </div>
    ) : (
      <div className="d-flex flex-column gap-3">
        {referenssit.map((item, index) => (
          <div
            key={
              item.id ||
              `referenssi-${index}`
            }
            style={{
              border: "1px solid #e3e9e3",
              borderLeft:
                "5px solid #04aa00",
              borderRadius: "12px",
              backgroundColor: "#ffffff",
              boxShadow:
                "0 3px 10px rgba(0,0,0,0.06)",
              overflow: "hidden",
            }}
          >
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                padding: "12px 16px",
                backgroundColor: "#f7fbf7",
                borderBottom:
                  "1px solid #e7ece7",
              }}
            >
              <div className="d-flex align-items-center gap-3">
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    backgroundColor:
                      "#04aa00",
                    color: "#fff",
                    fontWeight: "700",
                    fontSize: "13px",
                  }}
                >
                  {index + 1}
                </div>

                <div>
                  <div
                    className="fw-semibold"
                    style={{
                      color: "#315b31",
                    }}
                  >
                    {item.kohde ||
                      "Uusi referenssi"}
                  </div>

                  <div
                    className="text-muted"
                    style={{
                      fontSize: "12px",
                    }}
                  >
                    {item.tilaaja ||
                      "Tilaajaa ei määritetty"}

                    {item.toteutusvuosi
                      ? ` • ${item.toteutusvuosi}`
                      : ""}
                  </div>
                </div>
              </div>

              <Button
                type="button"
                size="sm"
                variant="outline-danger"
                onClick={() => {
                  if (item.id) {
                    setDeletedReferenssit(
                      (prev) => [
                        ...prev,
                        item.id,
                      ]
                    );
                  }

                  setReferenssit((prev) =>
                    prev.filter(
                      (_, i) => i !== index
                    )
                  );
                }}
              >
                Poista
              </Button>
            </div>

            <div
              style={{ padding: "16px" }}
            >
              <div className="row g-3">
                <div className="col-md-3">
                  <Form.Label className="fw-semibold small">
                    Kohde
                  </Form.Label>

                  <Form.Control
                    value={item.kohde || ""}
                    onChange={(e) =>
                      setReferenssit((prev) =>
                        prev.map((row, i) =>
                          i === index
                            ? {
                                ...row,
                                kohde:
                                  e.target
                                    .value,
                              }
                            : row
                        )
                      )
                    }
                  />
                </div>

                <div className="col-md-3">
                  <Form.Label className="fw-semibold small">
                    Tilaaja
                  </Form.Label>

                  <Form.Control
                    value={
                      item.tilaaja || ""
                    }
                    onChange={(e) =>
                      setReferenssit((prev) =>
                        prev.map((row, i) =>
                          i === index
                            ? {
                                ...row,
                                tilaaja:
                                  e.target
                                    .value,
                              }
                            : row
                        )
                      )
                    }
                  />
                </div>

                <div className="col-md-3">
                  <Form.Label className="fw-semibold small">
                    Tuote
                  </Form.Label>

                  <Form.Control
                    value={item.tuote || ""}
                    onChange={(e) =>
                      setReferenssit((prev) =>
                        prev.map((row, i) =>
                          i === index
                            ? {
                                ...row,
                                tuote:
                                  e.target
                                    .value,
                              }
                            : row
                        )
                      )
                    }
                  />
                </div>

                <div className="col-md-3">
                  <Form.Label className="fw-semibold small">
                    Toteutusvuosi
                  </Form.Label>

                  <Form.Control
                    type="number"
                    value={
                      item.toteutusvuosi ||
                      ""
                    }
                    onChange={(e) =>
                      setReferenssit((prev) =>
                        prev.map((row, i) =>
                          i === index
                            ? {
                                ...row,
                                toteutusvuosi:
                                  e.target
                                    .value,
                              }
                            : row
                        )
                      )
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
)}
          {editTab === "tyokokemus" && (
  <div>
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h6 className="mb-1 fw-bold">Työkokemus</h6>

        <small className="text-muted">
          Käyttäjän aikaisempi työkokemus
        </small>
      </div>

      <Button
        size="sm"
        onClick={() =>
          setTyokokemukset((prev) => [
            ...prev,
            {
              tyotehtava: "",
              yritys: "",
              alkamisvuosi: "",
              paattymisvuosi: "",
            },
          ])
        }
        style={{
          backgroundColor: "#04aa00",
          borderColor: "#04aa00",
        }}
      >
        + Lisää työkokemus
      </Button>
    </div>

    {tyokokemukset.length === 0 ? (
      <div
        className="text-center p-4 rounded"
        style={{
          backgroundColor: "#ffffff",
          border: "1px dashed #bfe8bf",
        }}
      >
        <div className="fw-semibold mb-1">
          Ei työkokemusta
        </div>

        <small className="text-muted">
          Lisää käyttäjän aikaisempi työkokemus.
        </small>
      </div>
    ) : (
      <div className="d-flex flex-column gap-3">
        {tyokokemukset.map((item, index) => (
          <div
            key={item.id || index}
            className="p-3 rounded"
            style={{
              backgroundColor: "#ffffff",
              border: "1px solid #d9f5d9",
              boxShadow: "0 2px 6px rgba(4,170,0,0.05)",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="fw-semibold">
                Työkokemus {index + 1}
              </div>

             <Button
  size="sm"
  variant="outline-danger"
  onClick={() => {
    if (item.id) {
      setDeletedTyokokemusIds((prev) => [
        ...prev,
        item.id,
      ]);
    }

    setTyokokemukset((prev) =>
      prev.filter((_, i) => i !== index)
    );
  }}
>
  Poista
</Button>
            </div>

            <div className="row g-3">
              <div className="col-md-6">
                <Form.Group>
                  <Form.Label className="fw-semibold">
                    Työtehtävä
                  </Form.Label>

                  <Form.Control
                    type="text"
                    placeholder="Esim. Kuntoarvioija"
                    value={item.tyotehtava || ""}
                    onChange={(event) =>
                      setTyokokemukset((prev) =>
                        prev.map((row, i) =>
                          i === index
                            ? {
                                ...row,
                                tyotehtava: event.target.value,
                              }
                            : row
                        )
                      )
                    }
                    style={{
                      borderColor: "#bfe8bf",
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group>
                  <Form.Label className="fw-semibold">
                    Yritys
                  </Form.Label>

                  <Form.Control
                    type="text"
                    placeholder="Esim. Waativa Oy"
                    value={item.yritys || ""}
                    onChange={(event) =>
                      setTyokokemukset((prev) =>
                        prev.map((row, i) =>
                          i === index
                            ? {
                                ...row,
                                yritys: event.target.value,
                              }
                            : row
                        )
                      )
                    }
                    style={{
                      borderColor: "#bfe8bf",
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group>
                  <Form.Label className="fw-semibold">
                    Alkamisvuosi
                  </Form.Label>

                  <Form.Control
                    type="number"
                    placeholder="2002"
                    min="1900"
                    max="2100"
                    value={item.alkamisvuosi || ""}
                    onChange={(event) =>
                      setTyokokemukset((prev) =>
                        prev.map((row, i) =>
                          i === index
                            ? {
                                ...row,
                                alkamisvuosi: event.target.value,
                              }
                            : row
                        )
                      )
                    }
                    style={{
                      borderColor: "#bfe8bf",
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group>
                  <Form.Label className="fw-semibold">
                    Päättymisvuosi
                  </Form.Label>

                  <Form.Control
                    type="number"
                    placeholder="2005"
                    min="1900"
                    max="2100"
                    value={item.paattymisvuosi || ""}
                    onChange={(event) =>
                      setTyokokemukset((prev) =>
                        prev.map((row, i) =>
                          i === index
                            ? {
                                ...row,
                                paattymisvuosi: event.target.value,
                              }
                            : row
                        )
                      )
                    }
                    style={{
                      borderColor: "#bfe8bf",
                    }}
                  />
                </Form.Group>
              </div>
            </div>

            {(item.alkamisvuosi || item.paattymisvuosi) && (
              <div
                className="mt-3 px-3 py-2 rounded small"
                style={{
                  backgroundColor: "#f4fff4",
                  border: "1px solid #d9f5d9",
                }}
              >
                Työsuhde:{" "}
                <strong>
                  {item.alkamisvuosi || "–"} –{" "}
                  {item.paattymisvuosi || "nykyinen"}
                </strong>
              </div>
            )}
          </div>
        ))}
      </div>
    )}
  </div>
)}
              {editTab === "patevyydet" && (
  <div>
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h6 className="mb-1 fw-bold">Pätevyydet</h6>
        <small className="text-muted">
          Käyttäjän pätevyydet ja niiden myöntäjät
        </small>
      </div>

      <Button
        size="sm"
        style={{
          backgroundColor: "#04aa00",
          borderColor: "#04aa00",
        }}
        onClick={() =>
          setPatevyydet((prev) => [
            ...prev,
            {
              patevyys: "",
              myontaja: "",
              suoritusvuosi: "",
            },
          ])
        }
      >
        + Lisää pätevyys
      </Button>
    </div>

    {patevyydet.length === 0 ? (
      <div
        className="text-center p-4 rounded"
        style={{
          backgroundColor: "#fff",
          border: "1px dashed #bfe8bf",
        }}
      >
        <small className="text-muted">
          Pätevyyksiä ei ole lisätty.
        </small>
      </div>
    ) : (
      patevyydet.map((item, index) => (
        <div
          key={item.id || index}
          className="p-3 rounded mb-2"
          style={{
            backgroundColor: "#fff",
            border: "1px solid #d9f5d9",
          }}
        >
          <div className="row g-2">
            <div className="col-md-4">
              <Form.Label className="fw-semibold">
                Pätevyys
              </Form.Label>

              <Form.Control
                value={item.patevyys}
                onChange={(e) =>
                  setPatevyydet((prev) =>
                    prev.map((row, i) =>
                      i === index
                        ? {
                            ...row,
                            patevyys: e.target.value,
                          }
                        : row
                    )
                  )
                }
              />
            </div>

            <div className="col-md-4">
              <Form.Label className="fw-semibold">
                Pätevyyden myöntäjä
              </Form.Label>

              <Form.Control
                value={item.myontaja}
                onChange={(e) =>
                  setPatevyydet((prev) =>
                    prev.map((row, i) =>
                      i === index
                        ? {
                            ...row,
                            myontaja: e.target.value,
                          }
                        : row
                    )
                  )
                }
              />
            </div>

            <div className="col-md-3">
              <Form.Label className="fw-semibold">
                Suoritusvuosi
              </Form.Label>

              <Form.Control
                type="number"
                value={item.suoritusvuosi}
                onChange={(e) =>
                  setPatevyydet((prev) =>
                    prev.map((row, i) =>
                      i === index
                        ? {
                            ...row,
                            suoritusvuosi:
                              e.target.value,
                          }
                        : row
                    )
                  )
                }
              />
            </div>

       <div className="col-md-1 d-flex align-items-end">
  <Button
    variant="outline-danger"
    onClick={() => {
      if (item.id) {
        setDeletedPatevyysIds((prev) => [
          ...prev,
          item.id,
        ]);
      }

      setPatevyydet((prev) =>
        prev.filter((_, i) => i !== index)
      );
    }}
  >
    ×
  </Button>
</div>
          </div>
        </div>
      ))
    )}
  </div>
)}
              {editTab === "kielitaito" && (
  <div>
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h6 className="mb-1 fw-bold">Kielitaito</h6>
        <small className="text-muted">
          Käyttäjän kielet ja taitotasot
        </small>
      </div>

      <Button
        size="sm"
        style={{
          backgroundColor: "#04aa00",
          borderColor: "#04aa00",
        }}
        onClick={() =>
          setKielitaidot((prev) => [
            ...prev,
            {
              kieli: "",
              taitotaso: "Hyvä",
            },
          ])
        }
      >
        + Lisää kieli
      </Button>
    </div>

    {kielitaidot.length === 0 ? (
      <div
        className="text-center p-4 rounded"
        style={{
          backgroundColor: "#fff",
          border: "1px dashed #bfe8bf",
        }}
      >
        <small className="text-muted">
          Kielitaitoja ei ole lisätty.
        </small>
      </div>
    ) : (
      kielitaidot.map((item, index) => (
        <div
          key={item.id || index}
          className="p-3 rounded mb-2"
          style={{
            backgroundColor: "#fff",
            border: "1px solid #d9f5d9",
          }}
        >
          <div className="row g-2">
            <div className="col-md-6">
              <Form.Label className="fw-semibold">
                Kieli
              </Form.Label>

              <Form.Control
                value={item.kieli}
                onChange={(e) =>
                  setKielitaidot((prev) =>
                    prev.map((row, i) =>
                      i === index
                        ? {
                            ...row,
                            kieli: e.target.value,
                          }
                        : row
                    )
                  )
                }
              />
            </div>

            <div className="col-md-5">
              <Form.Label className="fw-semibold">
                Taitotaso
              </Form.Label>

              <Form.Select
                value={item.taitotaso}
                onChange={(e) =>
                  setKielitaidot((prev) =>
                    prev.map((row, i) =>
                      i === index
                        ? {
                            ...row,
                            taitotaso: e.target.value,
                          }
                        : row
                    )
                  )
                }
              >
                <option value="Äidinkieli">
                  Äidinkieli
                </option>
                <option value="Hyvä">Hyvä</option>
                <option value="Tyydyttävä">
                  Tyydyttävä
                </option>
                <option value="Perusteet">
                  Perusteet
                </option>
              </Form.Select>
            </div>

            <div className="col-md-1 d-flex align-items-end">
             <Button
  variant="outline-danger"
  onClick={() => {
    if (item.id) {
      setDeletedKielitaitoIds((prev) => [
        ...prev,
        item.id,
      ]);
    }

    setKielitaidot((prev) =>
      prev.filter((_, i) => i !== index)
    );
  }}
>
  ×
</Button>
            </div>
          </div>
        </div>
      ))
    )}
  </div>
)}
              {editTab === "kayttooikeudet" && (
                <div>
                  <Form.Group>
                    <Form.Label className="fw-semibold">
                      Rooli
                    </Form.Label>

                    <Form.Select
                      value={editingUser.rooli}
                      onChange={(event) =>
                        handleEditFieldChange(
                          "rooli",
                          event.target.value
                        )
                      }
                      style={{ borderColor: "#bfe8bf" }}
                    >
                      {ROLE_OPTIONS.map((option) => (
                        <option
                          key={option.value}
                          value={option.value}
                        >
                          {option.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <div
                    className="mt-3 p-3 rounded"
                    style={{
                      backgroundColor: "#eefbee",
                      borderLeft: "4px solid #04aa00",
                    }}
                  >
                    <small className="text-muted">
                      Käyttäjän rooli määrittää, mitä toimintoja
                      hän voi käyttää järjestelmässä.
                    </small>
                  </div>
                </div>
              )}
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={handleCloseEditModal}
            disabled={savingEdit}
          >
            Sulje
          </Button>

          {editTab !== "laitehallinta" && (
            <Button
              onClick={handleSaveEditedUser}
              disabled={savingEdit || !editingUser}
              style={{
                backgroundColor: "#04aa00",
                borderColor: "#04aa00",
                minWidth: "170px",
              }}
            >
              {savingEdit ? (
                <>
                  <Spinner
                    animation="border"
                    size="sm"
                    className="me-2"
                  />
                  Tallennetaan...
                </>
              ) : (
                "Tallenna muutokset"
              )}
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {/* ------------------------------------------------------------------ */}
      {/* DEVICE MODAL */}
      {/* ------------------------------------------------------------------ */}

      <Modal
        show={showDeviceModal}
        onHide={handleCloseDeviceModal}
        centered
        size="lg"
        backdrop={
          savingDevice || savingMaintenance ? "static" : true
        }
        keyboard={!savingDevice && !savingMaintenance}
      >
        <Modal.Header
          closeButton={!savingDevice && !savingMaintenance}
          style={{
            background:
              "linear-gradient(135deg, #04aa00, #028a00)",
            color: "#fff",
            borderBottom: "none",
          }}
        >
          <div>
            <Modal.Title>
              {editingDevice.id ? "Muokkaa laitetta" : "Lisää laite"}
            </Modal.Title>
            <small style={{ opacity: 0.9 }}>
              Tutkimuskaluston tiedot ja huoltohistoria
            </small>
          </div>
        </Modal.Header>

        <Modal.Body
          style={{
            backgroundColor: "#f8fff8",
          }}
        >
          <div
            className="p-3 rounded mb-4"
            style={{
              backgroundColor: "#ffffff",
              border: "1px solid #d9f5d9",
            }}
          >
            <h6 className="fw-bold mb-3">Laitteen tiedot</h6>

            <div className="row g-3">
              <div className="col-md-6">
                <Form.Group>
                  <Form.Label className="fw-semibold">
                    Laitteen nimi
                  </Form.Label>
                  <Form.Control
                    value={editingDevice.laitenimi}
                    onChange={(event) =>
                      handleDeviceFieldChange(
                        "laitenimi",
                        event.target.value
                      )
                    }
                    placeholder="Esim. kosteusmittari"
                  />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group>
                  <Form.Label className="fw-semibold">
                    Merkki ja malli
                  </Form.Label>
                  <Form.Control
                    value={editingDevice.merkki_malli}
                    onChange={(event) =>
                      handleDeviceFieldChange(
                        "merkki_malli",
                        event.target.value
                      )
                    }
                    placeholder="Esim. Vaisala HM40"
                  />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group>
                  <Form.Label className="fw-semibold">
                    Hankintapäivä
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={editingDevice.hankintapaiva}
                    onChange={(event) =>
                      handleDeviceFieldChange(
                        "hankintapaiva",
                        event.target.value
                      )
                    }
                  />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group>
                  <Form.Label className="fw-semibold">
                    Vastuuhenkilö
                  </Form.Label>

                  <Form.Select
                    value={
                      editingDevice.varastossa
                        ? "varasto"
                        : editingDevice.vastuuhenkilo_id || ""
                    }
                    onChange={(event) =>
                      handleDeviceOwnerChange(event.target.value)
                    }
                  >
                    <option value="">
                      Valitse vastuuhenkilö
                    </option>
                    <option value="varasto">Varastossa</option>

                    {users.map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.nimi || user.sahkoposti}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
          </div>

          <div className="row g-3 mb-4">
            <div className="col-md-6">
              <div
                className="p-3 rounded h-100"
                style={{
                  backgroundColor: "#ffffff",
                  border: "1px solid #d9f5d9",
                }}
              >
                <Form.Check
                  type="switch"
                  id="device-leasing"
                  label="Leasing"
                  checked={Boolean(editingDevice.leasing)}
                  onChange={(event) =>
                    handleDeviceFieldChange(
                      "leasing",
                      event.target.checked
                    )
                  }
                />

                {editingDevice.leasing && (
                  <Form.Group className="mt-3">
                    <Form.Label className="fw-semibold">
                      Leasing päättymispäivä
                    </Form.Label>
                    <Form.Control
                      type="date"
                      value={
                        editingDevice.leasing_paattymispaiva
                      }
                      onChange={(event) =>
                        handleDeviceFieldChange(
                          "leasing_paattymispaiva",
                          event.target.value
                        )
                      }
                    />
                  </Form.Group>
                )}
              </div>
            </div>

            <div className="col-md-6">
              <div
                className="p-3 rounded h-100"
                style={{
                  backgroundColor: "#ffffff",
                  border: "1px solid #d9f5d9",
                }}
              >
                <Form.Check
                  type="switch"
                  id="device-calibration"
                  label="Kalibroitava laite"
                  checked={Boolean(editingDevice.kalibroitava)}
                  onChange={(event) =>
                    handleDeviceFieldChange(
                      "kalibroitava",
                      event.target.checked
                    )
                  }
                />

                {editingDevice.kalibroitava && (
                  <div className="row g-2 mt-2">
                    <div className="col-12">
                      <Form.Group>
                        <Form.Label className="fw-semibold">
                          Kalibrointipäivä
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={
                            editingDevice.kalibrointipaiva
                          }
                          onChange={(event) =>
                            handleDeviceFieldChange(
                              "kalibrointipaiva",
                              event.target.value
                            )
                          }
                        />
                      </Form.Group>
                    </div>

                    <div className="col-12">
                      <Form.Group>
                        <Form.Label className="fw-semibold">
                          Kalibroinnin uusintapäivä
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={
                            editingDevice.kalibroinnin_uusintapaiva
                          }
                          onChange={(event) =>
                            handleDeviceFieldChange(
                              "kalibroinnin_uusintapaiva",
                              event.target.value
                            )
                          }
                        />
                      </Form.Group>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div
            className="p-3 rounded"
            style={{
              backgroundColor: "#ffffff",
              border: "1px solid #d9f5d9",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h6 className="fw-bold mb-1">Huoltohistoria</h6>
                <small className="text-muted">
                  Lisää laitteelle huoltoja tarpeen mukaan
                </small>
              </div>
            </div>

            {!editingDevice.id && (
              <div className="alert alert-light border">
                Tallenna uusi laite ensin, jonka jälkeen voit
                lisätä huoltohistorian rivejä.
              </div>
            )}

            {editingDevice.id && (
              <>
                <div
                  className="p-3 rounded mb-3"
                  style={{
                    backgroundColor: "#f4fff4",
                    border: "1px solid #d9f5d9",
                  }}
                >
                  <div className="row g-2">
                    <div className="col-md-4">
                      <Form.Group>
                        <Form.Label className="small fw-semibold">
                          Päivämäärä
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={newMaintenance.paivamaara}
                          onChange={(event) =>
                            setNewMaintenance(
                              (previousMaintenance) => ({
                                ...previousMaintenance,
                                paivamaara: event.target.value,
                              })
                            )
                          }
                        />
                      </Form.Group>
                    </div>

                    <div className="col-md-8">
                      <Form.Group>
                        <Form.Label className="small fw-semibold">
                          Selite
                        </Form.Label>
                        <Form.Control
                          value={newMaintenance.selite}
                          onChange={(event) =>
                            setNewMaintenance(
                              (previousMaintenance) => ({
                                ...previousMaintenance,
                                selite: event.target.value,
                              })
                            )
                          }
                          placeholder="Esim. akku vaihdettu"
                        />
                      </Form.Group>
                    </div>
                  </div>

                  <div className="text-end mt-2">
                    <Button
                      size="sm"
                      variant="success"
                      disabled={savingMaintenance}
                      onClick={handleAddMaintenance}
                    >
                      {savingMaintenance
                        ? "Lisätään..."
                        : "+ Lisää huolto"}
                    </Button>
                  </div>
                </div>

                {maintenanceLoading ? (
                  <div className="text-center py-3">
                    <Spinner animation="border" size="sm" />
                  </div>
                ) : maintenanceRows.length === 0 ? (
                  <div className="text-muted small">
                    Huoltohistoriaa ei ole vielä lisätty.
                  </div>
                ) : (
                  <div className="d-flex flex-column gap-2">
                    {maintenanceRows.map((row) => (
                      <div
                        key={row.id}
                        className="d-flex justify-content-between align-items-start gap-3 p-2 rounded border"
                      >
                        <div>
                          <div className="small fw-semibold">
                            {formatDate(row.paivamaara)}
                          </div>
                          <div>{row.selite}</div>
                        </div>

                        <Button
                          size="sm"
                          variant="outline-danger"
                          onClick={() =>
                            handleDeleteMaintenance(row.id)
                          }
                        >
                          Poista
                        </Button>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={handleCloseDeviceModal}
            disabled={savingDevice || savingMaintenance}
          >
            Sulje
          </Button>

          <Button
            onClick={handleSaveDevice}
            disabled={savingDevice}
            style={{
              backgroundColor: "#04aa00",
              borderColor: "#04aa00",
              minWidth: "160px",
            }}
          >
            {savingDevice ? (
              <>
                <Spinner
                  animation="border"
                  size="sm"
                  className="me-2"
                />
                Tallennetaan...
              </>
            ) : editingDevice.id ? (
              "Tallenna muutokset"
            ) : (
              "Tallenna laite"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer position="bottom-end" className="p-3">
        <Toast
          bg={toast.bg}
          onClose={() =>
            setToast((previousToast) => ({
              ...previousToast,
              show: false,
            }))
          }
          show={toast.show}
          delay={3000}
          autohide
        >
          <Toast.Body className="text-white">
            {toast.message}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
}